"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var invariant = require("invariant");

var MapContext = react_1.createContext(null);

function useGoogleMap() {
  invariant(!!react_1.useContext, "useGoogleMap is React hook and requires React version 16.8+");
  var map = react_1.useContext(MapContext);
  invariant(!!map, "useGoogleMap needs a GoogleMap available up in the tree");
  return map;
}

exports.useGoogleMap = useGoogleMap;
exports.default = MapContext;